import React from "react";
import { CheckCircle, Archive } from "lucide-react";

/**
 * View toggle for Active / Inactive listing in master data pages.
 * Props:
 *  - view: "active" | "inactive"
 *  - onChange(next): callback
 *  - inactiveCount: number to badge (optional)
 */
export default function ActiveInactiveTabs({ view, onChange, inactiveCount, testIdPrefix = "view" }) {
  return (
    <div className="ai-tabs" data-testid={`${testIdPrefix}-tabs`}>
      <button
        type="button"
        className={`ai-tab ${view === "active" ? "ai-tab-on" : ""}`}
        onClick={() => onChange("active")}
        data-testid={`${testIdPrefix}-tab-active`}
      >
        <CheckCircle size={14} /> Active
      </button>
      <button
        type="button"
        className={`ai-tab ${view === "inactive" ? "ai-tab-on" : ""}`}
        onClick={() => onChange("inactive")}
        data-testid={`${testIdPrefix}-tab-inactive`}
      >
        <Archive size={14} /> Inactive
        {typeof inactiveCount === "number" && inactiveCount > 0 && (
          <span className="ai-tab-badge">{inactiveCount}</span>
        )}
      </button>
    </div>
  );
}
